import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { RichTextEditor } from 'components/atoms/rich-text-editor/rich-text-editor';
import styles from './cke.module.css';

const Header = styled.h5`
  flex: 1;
  margin: 0;
`;

export const DetailViewTitleInput: FC<{
  value: string;
  updateValue(text: string): void;
}> = ({ value, updateValue }) => {
  const [title, setTitle] = useState('');
  const updateRef = useRef<RichTextEditor>(null);

  useEffect(() => {
    setTitle(value);
  }, [value]);

  const handleOnChange = (data: string) => {
    setTitle(data);
  };

  const handleOnBlur = (data: string) => {
    updateValue(data);
  };

  const setData = useCallback(() => {
    updateRef.current?.setData();
  }, []);

  return (
    <>
      <Header>
        <RichTextEditor
          className={`${styles['template-title-input']}`}
          data={title}
          noToolbar
          noFormatting
          disallowMentions
          disallowImages
          allowSimpleVariables
          disallowNewLine
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          ref={updateRef}
          onInit={setData}
        />
      </Header>
    </>
  );
};
